import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// BigQuery SQL の「テスト実行」ボタンと結果モーダル。
// ワークフローを作成せずに SQL の結果 (JSON) を確認するための開発補助 UI。
import { useState } from 'react';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { apiClient } from '../../utils/apiClient';
export const BIGQUERY_PREVIEW_MAX_ROWS = 50;
const BigQuerySqlPreview = ({ tenantId, sql, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const run = async () => {
        setIsRunning(true);
        setResult(null);
        setError(null);
        setIsOpen(true);
        try {
            const response = await apiClient.susugi.etl.previewBigQuerySql(tenantId, sql.trim(), BIGQUERY_PREVIEW_MAX_ROWS);
            if (response.success && response.data) {
                setResult(response.data);
            }
            else {
                setError(response.error || 'SQL の実行に失敗しました');
            }
        }
        catch (caught) {
            setError(caught.message || 'SQL の実行に失敗しました');
        }
        finally {
            setIsRunning(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { type: "button", variant: "secondary", size: "sm", loading: isRunning, disabled: disabled || !sql.trim(), onClick: run, title: `SQL を実行して結果を最大 ${BIGQUERY_PREVIEW_MAX_ROWS} 行まで表示します（ワークフローは作成されません）`, children: "\u25B6 \u30C6\u30B9\u30C8\u5B9F\u884C" }), _jsxs(Modal, { isOpen: isOpen, onClose: () => setIsOpen(false), size: "xl", title: "\uD83E\uDDEA SQL \u30C6\u30B9\u30C8\u5B9F\u884C\u7D50\u679C", footer: _jsx(Button, { type: "button", variant: "secondary", onClick: () => setIsOpen(false), children: "\u9589\u3058\u308B" }), children: [isRunning && (_jsxs("div", { className: "flex items-center py-6 text-sm text-gray-600", children: [_jsx("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600 mr-2" }), "BigQuery \u3067\u5B9F\u884C\u4E2D..."] })), !isRunning && error && (_jsx("div", { className: "bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-800 whitespace-pre-wrap break-words", children: error })), !isRunning && result && (_jsxs("div", { className: "space-y-2", children: [_jsxs("div", { className: "text-xs text-gray-500", children: [result.row_count, " \u884C", result.row_count >= result.max_rows ? `（先頭 ${result.max_rows} 行のみ表示）` : '', ' • ', "\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u5B9F\u884C\u6642\u3068\u540C\u3058\u5F62\u5F0F\uFF08JSON \u914D\u5217\u30011 \u884C = 1 \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF09"] }), _jsx("pre", { className: "bg-gray-900 text-gray-100 text-xs rounded-md p-3 overflow-auto max-h-[60vh] whitespace-pre", children: JSON.stringify(result.rows, null, 2) })] }))] })] }));
};
export default BigQuerySqlPreview;
